import type { CardHooks } from "./registry";

/**
 * Wraith Spin — Medium Slash A/D.
 *
 *   - Attack: Power 4. If this attack DEALS damage (`damageDealt > 0`),
 *             return it to the player's hand. Once per round.
 *   - Defend: Dodge 4. If this defend FULL-BLOCKS the incoming attack,
 *             return it to the player's hand. Once per round.
 *   - Counter: if the opponent played a Medium-weight attack, −2 power
 *              on that attack. Data-driven via counterRules — no engine
 *              hook needed for the counter.
 *
 * The "once per round" gate is keyed by `onceFlagsThisRound["wraithSpin-
 * return"]` on the player. The engine's `applyResults` handler for
 * `returnSelfToHand` sets the flag after a successful return.
 *
 * `ctx.instanceId` is the AD-zone ZoneCard.id of THIS copy of Wraith Spin
 * (plumbed in by the combat hooks in playtestEngine.ts). The engine uses
 * it to find the exact entry to remove from `attackDefendZone`.
 */
const RETURN_FLAG = "wraithSpin-return";

export const wraithSpin: CardHooks = {
  onDamageDealt: (ctx) => {
    if (!ctx.instanceId) return {};
    if ((ctx.damageDealt ?? 0) <= 0) return {};
    if (ctx.self.onceFlagsThisRound?.[RETURN_FLAG]) return {};
    return {
      returnSelfToHand: {
        instanceId: ctx.instanceId,
        mode: "attack",
        flagKey: RETURN_FLAG,
      },
      log: [`${ctx.card.name} — dealt damage, returned to hand.`],
    };
  },
  onFullBlock: (ctx) => {
    if (!ctx.instanceId) return {};
    if (!ctx.fullBlock) return {};
    if (ctx.self.onceFlagsThisRound?.[RETURN_FLAG]) return {};
    return {
      returnSelfToHand: {
        instanceId: ctx.instanceId,
        mode: "defend",
        flagKey: RETURN_FLAG,
      },
      log: [`${ctx.card.name} — full block, returned to hand.`],
    };
  },
};
